import Chart from "react-apexcharts";
import { dimensionParticipation } from "../../../services/api-services";
import { useEffect, useState } from "react";
import { API_RESPONSE } from "../../../utills/app-constant";
import { toastEmitter } from "../../../utills/utilities";
import generateChartImage from "./generateChartImage";
import Remark from "./Remark";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DimensionDetails = ({ selectedCompanyId, graphName }) => {
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [remark, setRemark] = useState(""); // For remark text
  const [remarkId, setRemarkId] = useState(null); // For remarkId
  const [isAttempt, setIsAttempt] = useState("")

  const [chartData, setChartData] = useState({
    series: [{ name: "Number of Participants", data: [] }],
    options: {
      chart: {
        id: 'dimension_participation',
        type: "bar",
        // events: {
        //   mounted: () => generateChartImage("dimension_participation","dimension_participation"), // Call the updated function here
        // },
        margin: {
          right: 50,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "40%",
          dataLabels: {
            position: "end",
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetX: 50,
        style: {
          fontSize: "12px",
          colors: ["#000"],
        },
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        categories: [],
        min: 0,
        max: 60,
        tickAmount: 13,
        labels: {
          formatter: function (val) {
            return `${Math.floor(val / 5) * 5}`;
          },
        },
      },
      colors: ["#4D76A1"],
      grid: {
        padding: {
          right: 60,
        },
      },
    },
  });

  const getAllDimensionParticipationData = async () => {
    setLoading(true);
    try {
      const response = await dimensionParticipation(selectedCompanyId, graphName);
      if (response?.data?.responseCode === 200) {
        setRowData(response?.data);
        const remark = response?.data?.remark || "";
        const remarkId = response?.data?.remarkId || null;
        const isAttempt = response?.data?.isAttempt ?? 0;
        setRemark(remark);
        setRemarkId(remarkId);
        setIsAttempt(isAttempt);
        const dimensionNames = response?.data?.responseBody.map((item) => item.dimensionName);
        const dimensionCounts = response?.data?.responseBody.map((item) => item.count);

        const maxCount = Math.max(...dimensionCounts);
        const tickAmount = Math.ceil(maxCount / 5);

        setChartData({
          series: [
            {
              name: "Number of Participants",
              data: dimensionCounts,
            },
          ],
          options: {
            ...chartData.options,
            xaxis: {
              categories: dimensionNames,
            },
            yaxis: {
              categories: dimensionNames,
              min: 0,
              max: Math.ceil(maxCount / 10) * 10,
              tickAmount: tickAmount,
            },
          },
        });
      } else if (response?.data?.responseCode === 404) {
        setRowData([]);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllDimensionParticipationData();
  }, [selectedCompanyId]);

  useEffect(() => {
    if (chartData.series.some(series => series.data.some(val => val > 0))) {
      setTimeout(() => {
        generateChartImage('dimension_participation', 'dimension_participation', rowData?.remark);
      }, 100); // Delay to ensure the chart is mounted
    }
  }, [rowData, chartData.series]);

  const exportSummaryToExcel = (data, fileName = "Dimension Participation Details") => {
    let worksheet;

    // Case: Array of dimensions
    const headers = ["Dimension Name", "Count"];
    const rows = data && data?.responseBody?.map(item => [item?.dimensionName, item?.count]);
    worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, fileName);
  };

  return (
    <>
      <div className="text-end">
        <button className="px-3 py-2 text-white bg-primary rounded border-0" onClick={() => exportSummaryToExcel(rowData)}>Download Excel</button>
      </div>
      <div className="dimensionDetails">
        {loading ? (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : (
          <div className="chart2" data-heading="Dimension Participation Details" data-remark={remark}>
            <Chart
              options={chartData?.options}
              series={chartData?.series}
              type="bar"
              height={280}
            />
          </div>
        )}
        <Remark selectedCompanyId={selectedCompanyId} graphName="DimensionParticipationDetails" initialRemark={remark} remarkId={remarkId} isAttempt={isAttempt} setRemarkprops={setRemark} />

      </div>
    </>
  );
};

export default DimensionDetails;
